Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "buttonnext961135942",
  {"root":"buttonnext961135942--root","content":"buttonnext961135942--content","prefix":"buttonnext961135942--prefix","suffix":"buttonnext961135942--suffix"},
  ".buttonnext961135942--root{display:inline-flex;align-items:center;cursor:pointer}.buttonnext961135942--prefix{flex-shrink:0}.buttonnext961135942--suffix{flex-shrink:0}.buttonnext961135942--root[data-buttonnext961135942-disabled]{cursor:default}.buttonnext961135942--root[disabled]{pointer-events:none}",
  2,
  "buttonnext961135942"
);
__webpack_require__.stylable.$.register(exports.default)
